define.alias("ember-math-helpers/helpers/min", "media/helpers/min");